<template>
  <div class="summary__container px-4 d-flex flex-column">
    <div class="summary__title mb-2 typo-heading16 weight-500">{{ $tc('downgrade.confirm.summary.heading') }}</div>
    <div class="summary__payment-status d-flex flex-column">
      <div class="summary__payment-status-item d-flex align-items-center justify-content-between mb-1">
        <div class="summary__payment-status-item-label" v-html="choosedPlanLabel"></div>
        <div class="summary__payment-status-item-price" v-html="planPrice"></div>
      </div>
    </div>
    <div class="summary__divider" />
    <div class="summary__action">
      <a @click.stop="goToPayment">
        <button class="summary__action-btn btn btn-default btn-danger2 px-3">{{ $t('downgrade.confirm.summary.downgrade',
          {
            plan: choosedPlanText
          }) }}</button>
      </a>
    </div>
  </div>
</template>

<script>
import { serverDomain } from "@/config/index.js";
import { mapState, mapActions } from "vuex";

export default {
  name: 'SummaryBlock',
  props: {
    isYearly: Boolean,
    choosedPlan: String,
    choosedPlanText: String,
    planPrice: String
  },
  computed: {
    ...mapState("account", {
      account: state => state.shopInfo,
      plan: state => state.shopInfo.plan
    }),
    choosedPlanLabel() {
      let interval = this.$t('downgrade.confirm.choosedPlan.billingInterval.monthly');
      if (this.isYearly) {
        interval = this.$t('downgrade.confirm.choosedPlan.billingInterval.yearly');
      }
      return `${this.choosedPlanText} (${interval})`
    }
  },
  methods: {
    ...mapActions("dashboard", {
      pricingChargeAction: "pricingChargeAction"
    }),
    goToPayment() {
      const plan = this.choosedPlan;
      let url = serverDomain() + "/admin/payment/charge?plan=" + plan + "&shop=" + this.account.shopifyDomain;

      if (this.isYearly) {
        url += "&type=annually"
      }
      this.pricingChargeAction(url).then(res => {
        if (res && res.data && res.data.redirect_url) {
          window.top.location = res.data.redirect_url;
        }
      })
    }
  },
}
</script>

<style lang="scss">
.summary {
  &__divider {
    width: 100%;
    border-bottom: solid 1px rgba(73, 73, 73, 0.1);
    margin: 16px 0;
  }

  &__container {
    width: 470px;
    background-color: $light2;
    border-left: solid 1px rgba(73, 73, 73, 0.1);
    padding-top: 44px;
  }

  &__payment-status-item {
    &-label {
      font-size: 12px;
      line-height: 18px;
    }

    &-price {
      font-size: 14px;
      font-weight: 500;
    }
  }

  &__action {
    &-message {
      font-size: 12px;
    }

    &-btn {
      width: 100%;
    }
  }
}

@media screen and (max-width: 1340px) {
  .summary__container {
    width: 400px;
    margin-left: 40px;
  }
}
</style>
